// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentWithdrawDialog-ButtonContainer_cls1__bLZH+","cls2":"PaymentWithdrawDialog-ButtonContainer_cls2__sPGw0 PaymentWithdrawDialog-ButtonContainer_cls1__bLZH+"};